export default function isMobile() {
  return window.matchMedia('only screen and (max-width: 699px)').matches
}
